import { useI18n } from "hooks/i18n/i18n";
import { useDisclosure } from "hooks/useDisclosure";
import React from "react";

import { LiveCommerceDrawer } from "./LiveCommerceDrawer";
import { LiveCommercePurchaseBar } from "./LiveCommercePurchaseBar";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { FC } from "react";

export const LiveCommerceFooter: FC<{
  isDisabled: boolean;
  itemNum: number;
  pseudoCart: (ProductData & { count: number })[];
  onClickButton: () => void;
  decrementGoodsCount: (itemData: ProductData) => void;
  incrementGoodsCount: (itemData: ProductData) => void;
}> = ({
  isDisabled,
  itemNum,
  pseudoCart,
  onClickButton,
  decrementGoodsCount,
  incrementGoodsCount,
}) => {
  const { t } = useI18n();
  const {
    isOpen: isDrawerOpen,
    onClose: onDrawerClose,
    onToggle: onDrawerToggle,
  } = useDisclosure();

  return (
    <React.Fragment>
      <LiveCommerceDrawer
        isDrawerOpen={isDrawerOpen}
        pseudoCart={pseudoCart}
        decrementGoodsCount={decrementGoodsCount}
        incrementGoodsCount={incrementGoodsCount}
        onClickCloseDrawer={onDrawerClose}
      />

      <LiveCommercePurchaseBar
        isDrawerOpen={isDrawerOpen}
        isDisabled={isDisabled}
        inCartNum={itemNum}
        pseudoCart={pseudoCart}
        buttonText={t("streaming.commerceGoodsList.next")}
        onClickButton={onClickButton}
        onClickDrawerOpen={onDrawerToggle}
      />
    </React.Fragment>
  );
};
